module.exports = __webpack_public_path__ + "img/stage_warehouse_operation.64177e35.svg";